(() => {
  let kraftImage = null;
  const kraftSource = document.currentScript?.src;
  const kraftReady = new Promise((resolve) => {
    if (!kraftSource || !window.Image) { resolve(null); return; }
    const image = new window.Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => { kraftImage = image; resolve(image); };
    image.onerror = () => resolve(null);
    image.src = new URL('kraft-texture-v1.png', kraftSource).href;
  });
  window.RollMyLogoKraft = { ready: kraftReady, style(ctx, x, y, width, height, grainScale = 1) {
    if (!kraftImage) return '#c9a174';
    const pattern = ctx.createPattern(kraftImage, 'no-repeat');
    if (!pattern?.setTransform) return '#c9a174';
    // Keep the paper grain visible in small previews instead of shrinking the whole image.
    const scale = Math.max(grainScale, width / kraftImage.naturalWidth, height / kraftImage.naturalHeight);
    pattern.setTransform({ a: scale, b: 0, c: 0, d: scale,
      e: x + (width - kraftImage.naturalWidth * scale) / 2,
      f: y + (height - kraftImage.naturalHeight * scale) / 2 });
    return pattern;
  } };
  const demoCartKey = 'rollmylogo-demo-cart';
  const isPreview = document.body.hasAttribute('data-rml-preview');
  const fonts = Object.fromEntries((window.RollMyLogoFonts || []).map((font) => [font.key, font]));

  const readDemoCart = () => {
    try {
      return JSON.parse(window.localStorage.getItem(demoCartKey) || '[]');
    } catch (_error) {
      return [];
    }
  };

  const updateDemoCartCount = () => {
    if (!isPreview) return;
    const count = readDemoCart().reduce((total, item) => total + Number(item.quantity || 0), 0);
    document.querySelectorAll('[data-rml-cart-count]').forEach((element) => {
      element.textContent = String(count);
    });
  };

  updateDemoCartCount();
  document.addEventListener('rollmylogo:cart-updated', updateDemoCartCount);

  const quoteDialog = document.querySelector('[data-rml-quote-dialog]');
  const openQuoteDialog = () => {
    if (!quoteDialog) return;
    if (typeof quoteDialog.showModal === 'function') {
      if (!quoteDialog.open) quoteDialog.showModal();
    } else {
      quoteDialog.setAttribute('open', '');
    }
    window.requestAnimationFrame(() => quoteDialog.querySelector('input')?.focus());
  };
  const closeQuoteDialog = () => {
    if (!quoteDialog) return;
    if (typeof quoteDialog.close === 'function') quoteDialog.close();
    else quoteDialog.removeAttribute('open');
  };

  document.querySelectorAll('[data-rml-quote-open]').forEach((button) => {
    button.addEventListener('click', openQuoteDialog);
  });
  document.querySelectorAll('[data-rml-quote-close]').forEach((button) => {
    button.addEventListener('click', closeQuoteDialog);
  });
  quoteDialog?.addEventListener('click', (event) => {
    if (event.target === quoteDialog) closeQuoteDialog();
  });

  const quoteState = document.querySelector('[data-rml-quote-state]');
  if (quoteState && quoteState.dataset.state !== 'idle') openQuoteDialog();

  const demoQuoteForm = document.querySelector('[data-rml-quote-demo]');
  demoQuoteForm?.addEventListener('submit', (event) => {
    event.preventDefault();
    const success = demoQuoteForm.querySelector('[data-rml-quote-demo-success]');
    if (success) success.hidden = false;
    demoQuoteForm.reset();
  });

  document.querySelectorAll('.rml-applications').forEach((section, carouselIndex) => {
    const track = section.querySelector('.rml-applications__grid'), slides = [...track.querySelectorAll('.rml-application-card')];
    if (slides.length < 2 || !window.lucide) return;
    const mobile = window.matchMedia('(max-width: 760px)'), reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    track.id ||= `rml-applications-track-${carouselIndex}`;
    const controls = document.createElement('div'); controls.className = 'rml-applications__controls';
    controls.setAttribute('role', 'group'); controls.setAttribute('aria-label', 'Where it works navigation');
    const arrow = (label, icon) => {
      const button = document.createElement('button'); button.type = 'button'; button.className = 'rml-applications__arrow';
      button.title = label; button.setAttribute('aria-label', label); button.setAttribute('aria-controls', track.id);
      const glyph = window.lucide.createElement(icon); glyph.setAttribute('aria-hidden', 'true'); button.append(glyph);
      return button;
    };
    const previous = arrow('Previous application', window.lucide.ArrowLeft), next = arrow('Next application', window.lucide.ArrowRight);
    const dots = document.createElement('div'); dots.className = 'rml-applications__dots';
    let active = 0, settleTimer = 0;
    const buttons = slides.map((slide, index) => {
      const button = document.createElement('button'); button.type = 'button'; button.className = 'rml-applications__dot';
      const title = slide.querySelector('h3').textContent.trim();
      button.title = title; button.setAttribute('aria-label', `Show ${title}`); button.setAttribute('aria-controls', track.id);
      button.addEventListener('click', () => go(index)); dots.append(button); return button;
    });
    const update = () => {
      previous.disabled = active === 0; next.disabled = active === slides.length - 1;
      buttons.forEach((button, index) => button.setAttribute('aria-current', String(index === active)));
    };
    const position = index => Math.min(slides[index].offsetLeft - slides[0].offsetLeft, track.scrollWidth - track.clientWidth);
    function go(index, smooth = true) {
      if (!mobile.matches) return;
      clearTimeout(settleTimer); active = Math.max(0, Math.min(slides.length - 1, index)); update();
      track.scrollTo({ left: position(active), behavior: smooth && !reducedMotion.matches ? 'smooth' : 'instant' });
    }
    previous.addEventListener('click', () => go(active - 1)); next.addEventListener('click', () => go(active + 1));
    track.addEventListener('scroll', () => {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(() => {
        if (!mobile.matches) return;
        active = slides.reduce((closest, _, index) => Math.abs(position(index) - track.scrollLeft) < Math.abs(position(closest) - track.scrollLeft) ? index : closest, 0);
        update();
      }, 140);
    }, { passive: true });
    track.addEventListener('keydown', event => {
      if (!mobile.matches || event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault(); go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1));
    });
    controls.append(previous, dots, next); track.after(controls); section.classList.add('rml-applications--carousel');
    const configure = () => {
      if (mobile.matches) {
        section.setAttribute('role', 'region'); section.setAttribute('aria-roledescription', 'carousel'); section.setAttribute('aria-label', 'Where it works');
        track.tabIndex = 0; track.setAttribute('aria-label', 'Application photos');
        slides.forEach((slide, index) => { slide.setAttribute('role', 'group'); slide.setAttribute('aria-roledescription', 'slide'); slide.setAttribute('aria-label', `${index + 1} of ${slides.length}: ${slide.querySelector('h3').textContent.trim()}`); });
        requestAnimationFrame(() => go(active, false));
      } else {
        clearTimeout(settleTimer);
        ['role', 'aria-roledescription', 'aria-label'].forEach(name => section.removeAttribute(name));
        track.removeAttribute('tabindex'); track.removeAttribute('aria-label');
        slides.forEach(slide => ['role', 'aria-roledescription', 'aria-label'].forEach(name => slide.removeAttribute(name)));
      }
    };
    mobile.addEventListener('change', configure);
    new ResizeObserver(() => { if (mobile.matches) go(active, false); }).observe(track);
    update(); configure();
  });

  document.querySelectorAll('[data-rml-builder]').forEach((root) => {
    if (root.hasAttribute?.('data-rml-editor')) {
      if (window.RollMyLogoEditor) window.RollMyLogoEditor.init(root);
      else {
        root.querySelector('[data-rml-add]').disabled = true;
        root.querySelector('[data-rml-field-status]').textContent = 'Editor could not load. Please reload the page.';
      }
      return;
    }
    const canvas = root.querySelector('[data-rml-canvas]');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const textInput = root.querySelector('[data-rml-text]');
    const fontInput = root.querySelector('[data-rml-font]');
    const fontStatus = root.querySelector('[data-rml-font-status]');
    const lineInput = root.querySelector('[data-rml-line-width]');
    const linesInput = root.querySelector('[data-rml-lines]');
    const lineOutput = root.querySelector('[data-rml-line-output]');
    const sizeInput = root.querySelector('[data-rml-size]');
    const sizeOutput = root.querySelector('[data-rml-size-output]');
    const rollerOutput = root.querySelector('[data-rml-roller-output]');
    const uploadInput = root.querySelector('[data-rml-upload]');
    const uploadName = root.querySelector('[data-rml-upload-name]');
    const uploadFile = root.querySelector('[data-rml-upload-file]');
    const uploadThumb = root.querySelector('[data-rml-upload-thumb]');
    const uploadAction = root.querySelector('[data-rml-upload-action]');
    const uploadStatus = root.querySelector('[data-rml-upload-status]');
    const whiteInput = root.querySelector('[data-rml-remove-white]');
    const backgroundControl = root.querySelector('[data-rml-background-control]');
    const textControl = root.querySelector('[data-rml-text-control]');
    const inverseInput = root.querySelector('[data-rml-inverse]');
    const addButton = root.querySelector('[data-rml-add]');
    const toast = document.querySelector('[data-rml-toast]');
    const productForm = root.querySelector('form.rml-builder__grid');
    const designInput = root.querySelector('[data-rml-design-data]');
    if (!fonts.montserrat) {
      if (fontStatus) fontStatus.textContent = 'Font catalog could not be loaded. Please reload the page.';
      if (addButton) addButton.disabled = true;
      return;
    }

    const state = {
      text: textInput?.value || 'ROLLMYLOGO',
      size: Number(sizeInput?.value || 58),
      ink: '#09090a',
      surface: '#c9a36a',
      roller: 40,
      offsetX: 58,
      offsetY: 0,
      dragging: false,
      lastX: 0,
      lastY: 0,
      logo: null,
      source: null,
      mode: 'text',
      filename: '',
      loading: false,
      removeWhite: true,
      inverse: false,
      fontKey: 'montserrat',
      fontReady: !document.fonts,
      textSupported: true,
      fits: true,
      lines: Boolean(linesInput?.checked),
      lineWidth: Number(lineInput?.value || 4),
    };

    const tintedLogo = document.createElement('canvas');
    const fieldCanvas = root.querySelector('[data-rml-field]');
    const fieldStatus = root.querySelector('[data-rml-field-status]');
    const wheelMask = document.createElement('canvas');
    const fieldImage = document.createElement('canvas');
    let uploadVersion = 0;
    let formReady = false;
    let fontVersion = 0;
    let layout = {};

    const syncSaveButton = () => {
      if (addButton) addButton.disabled = !state.fits || state.loading || (state.mode !== 'logo' && (!state.fontReady || !state.textSupported));
    };

    const draw = () => {
      const rect = canvas.getBoundingClientRect();
      const width = rect.width;
      const height = rect.height;
      ctx.clearRect(0, 0, width, height);
      ctx.fillStyle = state.surface;
      ctx.fillRect(0, 0, width, height);

      ctx.save();
      ctx.fillStyle = state.inverse ? state.surface : state.ink;
      const font = fonts[state.fontKey];
      ctx.font = `${font.style || 'normal'} ${font.weight} ${state.size}px "RML ${font.family}"`;
      if ('fontVariationSettings' in ctx) ctx.fontVariationSettings = font.variable ? `"wght" ${font.weight}` : 'normal';
      ctx.textBaseline = 'alphabetic';

      const label = state.mode === 'logo' || !state.fontReady || !state.textSupported ? '' : state.text;
      const metrics = ctx.measureText(label);
      const textWidth = metrics.width;
      const ascent = label ? Math.max(0, metrics.actualBoundingBoxAscent ?? state.size * .8) : 0;
      const descent = label ? Math.max(0, metrics.actualBoundingBoxDescent ?? state.size * .2) : 0;
      const logo = state.mode !== 'text' && state.logo;
      const scale = logo ? state.size * 1.45 / logo.height : 0;
      const logoWidth = logo ? logo.width * scale : 0;
      const logoHeight = logo ? logo.height * scale : 0;
      const gap = logo && label ? 22 : 0;
      const repeatLengthMm = Math.PI * state.roller;
      const pixelsPerMm = 6;
      const unitWidth = repeatLengthMm * pixelsPerMm;
      const printHeight = 18.7 * pixelsPerMm;
      const rail = state.lines ? state.lineWidth : 0;
      const availableWidth = unitWidth - 24;
      const availableHeight = printHeight - 2 * rail - 8;
      // Reserve space for optional rails without changing the user's size or depending on diameter.
      const artworkScale = availableHeight / (printHeight - 8);
      const artworkWidth = (textWidth + logoWidth + gap) * artworkScale;
      const artworkHeight = Math.max(logoHeight, ascent + descent) * artworkScale;
      state.fits = artworkWidth <= availableWidth && artworkHeight <= availableHeight;
      const start = ((state.offsetX % unitWidth) + unitWidth) % unitWidth - unitWidth;
      const halfArtwork = Math.max(logoHeight / 2, (ascent + descent) / 2) * artworkScale;
      const halfHeight = halfArtwork + 10 + rail + 2;
      state.offsetY = Math.max(halfHeight, Math.min(height - halfHeight, state.offsetY));
      const topLine = Math.floor(state.offsetY - halfArtwork - 10 - rail);
      const bottomLine = Math.ceil(state.offsetY + halfArtwork + 10);
      layout = {
        repeatWidthPx: unitWidth, repeatLengthMm, pixelsPerMm,
        artworkScale, artworkWidthPx: artworkWidth,
        fontSizeMm: state.size * artworkScale / pixelsPerMm,
        artworkWidthMm: artworkWidth / pixelsPerMm, artworkHeightMm: artworkHeight / pixelsPerMm,
        availableWidthMm: availableWidth / pixelsPerMm, availableHeightMm: availableHeight / pixelsPerMm,
        printWidthMm: 18.7, fits: state.fits,
        topPx: topLine, bottomPx: bottomLine,
      };

      if (state.inverse) {
        ctx.fillStyle = state.ink;
        ctx.fillRect(0, topLine, width, bottomLine + rail - topLine);
      }
      ctx.fillStyle = state.inverse ? state.surface : state.ink;

      if (logo) {
        tintedLogo.width = logo.width;
        tintedLogo.height = logo.height;
        const tint = tintedLogo.getContext('2d');
        tint.drawImage(logo, 0, 0);
        tint.globalCompositeOperation = 'source-in';
        tint.fillStyle = ctx.fillStyle;
        tint.fillRect(0, 0, logo.width, logo.height);
      }

      for (let x = start; x < width + unitWidth; x += unitWidth) {
        ctx.save();
        ctx.beginPath(); ctx.rect(x, 0, unitWidth - 24, height); ctx.clip();
        ctx.translate(x, state.offsetY);
        ctx.scale(artworkScale, artworkScale);
        if (logo) ctx.drawImage(tintedLogo, 0, -logoHeight / 2, logoWidth, logoHeight);
        if (label) ctx.fillText(label, logoWidth + gap, (ascent - descent) / 2);
        ctx.restore();
      }

      if (state.lines) {
        ctx.fillStyle = state.ink;
        ctx.fillRect(0, topLine, width, rail);
        ctx.fillRect(0, bottomLine, width, rail);
      }
      ctx.restore();

      if (wheelMask) {
        // Fixed design pixels per mm: diameter never resizes text or artwork.
        wheelMask.width = 1024;
        wheelMask.height = 160;
        const mask = wheelMask.getContext('2d');
        const mmWidth = 18.7 * pixelsPerMm;
        mask.fillStyle = '#000'; mask.fillRect(0, 0, wheelMask.width, wheelMask.height);
        mask.save(); mask.scale(wheelMask.width / unitWidth, wheelMask.height / mmWidth);
        if (state.inverse) { mask.fillStyle = '#fff'; mask.fillRect(0, 0, unitWidth, mmWidth); }
        const phase = state.offsetX - 58;
        const origin = (unitWidth - artworkWidth) / 2 + phase;
        const vertical = state.offsetY - height / 2;
        state.fits = state.fits && origin >= 12 && origin + artworkWidth <= unitWidth - 12 && Math.abs(vertical) + artworkHeight / 2 <= availableHeight / 2;
        layout.fits = state.fits;
        mask.save(); mask.beginPath(); mask.rect(12, rail + 4, unitWidth - 24, availableHeight); mask.clip();
        for (let repeat = 0; repeat < 1; repeat++) {
          mask.save(); mask.translate(origin + repeat * unitWidth, mmWidth / 2 + vertical); mask.scale(artworkScale, artworkScale);
          mask.fillStyle = state.inverse ? '#000' : '#fff';
          mask.font = `${font.style || 'normal'} ${font.weight} ${state.size}px "RML ${font.family}"`;
          if ('fontVariationSettings' in mask) mask.fontVariationSettings = font.variable ? `"wght" ${font.weight}` : 'normal';
          if (logo) {
            // Use the existing alpha mask; recolor without changing transparent holes.
            const tint = tintedLogo.getContext('2d');
            tint.clearRect(0, 0, tintedLogo.width, tintedLogo.height);
            tint.globalCompositeOperation = 'source-over'; tint.drawImage(logo, 0, 0);
            tint.globalCompositeOperation = 'source-in'; tint.fillStyle = state.inverse ? '#000' : '#fff';
            tint.fillRect(0, 0, logo.width, logo.height);
            mask.drawImage(tintedLogo, 0, -logoHeight / 2, logoWidth, logoHeight);
          }
          if (label) mask.fillText(label, logoWidth + gap, (ascent - descent) / 2);
          mask.restore();
        }
        mask.restore();
        mask.fillStyle = '#fff';
        mask.fillRect(0, 0, unitWidth, rail); mask.fillRect(0, mmWidth - rail, unitWidth, rail);
        mask.restore();
        root.rmlDesign = { mask: wheelMask, diameter: state.roller, printWidthMm: 18.7, lines: state.lines, inverse: state.inverse, fits: state.fits, previewLayout: { ...layout } };
        root.dispatchEvent(new CustomEvent('rollmylogo:design', { detail: root.rmlDesign }));
        if (fieldCanvas) {
          const fieldRect = fieldCanvas.getBoundingClientRect();
          const ratio = Math.min(window.devicePixelRatio || 1, 2);
          fieldCanvas.width = Math.max(1, Math.round(fieldRect.width * ratio));
          fieldCanvas.height = Math.max(1, Math.round(fieldRect.height * ratio));
          const field = fieldCanvas.getContext('2d');
          field.setTransform(ratio, 0, 0, ratio, 0, 0);
          const screenScale = Math.max(1, fieldRect.width - 24) / (Math.PI * 60);
          const fw = repeatLengthMm * screenScale, fh = 18.7 * screenScale;
          fieldImage.width = wheelMask.width; fieldImage.height = wheelMask.height;
          const pixels = mask.getImageData(0, 0, wheelMask.width, wheelMask.height);
          const color = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
          const paper = color(state.surface), ink = color(state.ink);
          for (let i = 0; i < pixels.data.length; i += 4) {
            const weight = pixels.data[i] / 255;
            for (let c = 0; c < 3; c++) pixels.data[i + c] = paper[c] * (1 - weight) + ink[c] * weight;
          }
          fieldImage.getContext('2d').putImageData(pixels, 0, 0);
          const fy = (fieldRect.height - fh) / 2;
          field.drawImage(fieldImage, 12, fy, fw, fh);
          field.strokeStyle = state.fits ? '#56595d' : '#bd2424';
          field.lineWidth = 1; field.setLineDash([4, 3]); field.strokeRect(12, fy, fw, fh);
          field.strokeRect(12 + 2 * screenScale, fy + (rail + 4) / pixelsPerMm * screenScale,
            (repeatLengthMm - 4) * screenScale, availableHeight / pixelsPerMm * screenScale);
          const dimensions = root.querySelector('[data-rml-field-size]');
          const used = root.querySelector('[data-rml-field-used]');
          if (dimensions) dimensions.textContent = `${repeatLengthMm.toFixed(1)} × 18.7 mm`;
          if (used) used.textContent = `Artwork: ${(artworkWidth / pixelsPerMm).toFixed(1)} / ${(availableWidth / pixelsPerMm).toFixed(1)} mm`;
        }
        if (fieldStatus) {
          const excessX = Math.max(0, 12 - origin, origin + artworkWidth - unitWidth + 12) / pixelsPerMm;
          const excessY = Math.max(0, Math.abs(vertical) + artworkHeight / 2 - availableHeight / 2) / pixelsPerMm;
          fieldStatus.textContent = state.fits ? '' : `Outside print area: ${excessX.toFixed(1)} mm horizontally, ${excessY.toFixed(1)} mm vertically.`;
          fieldStatus.dataset.error = String(!state.fits);
        }
        syncSaveButton();
      }
    };

    const resize = () => {
      const rect = canvas.getBoundingClientRect();
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.max(1, Math.floor(rect.width * ratio));
      canvas.height = Math.max(1, Math.floor(rect.height * ratio));
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      if (!state.offsetY) state.offsetY = rect.height / 2;
      draw();
    };

    const setPressed = (groupSelector, active) => {
      root.querySelectorAll(groupSelector).forEach((item) => {
        item.setAttribute('aria-pressed', String(item === active));
      });
    };

    const setMode = (mode) => {
      state.mode = mode;
      root.querySelectorAll('[data-rml-mode]').forEach((button) => {
        button.disabled = button.dataset.rmlMode !== 'text' && !state.logo;
        button.setAttribute('aria-pressed', String(button.dataset.rmlMode === mode));
      });
      if (textControl) textControl.hidden = mode === 'logo';
      if (backgroundControl) backgroundControl.hidden = !state.source || mode === 'text';
      if (uploadAction) uploadAction.textContent = state.logo ? 'Replace logo' : 'Upload your logo';
      syncSaveButton();
      draw();
    };

    root.querySelectorAll('[data-rml-mode]').forEach((button) => {
      button.addEventListener('click', () => setMode(button.dataset.rmlMode));
    });

    const centerArtwork = () => {
      state.offsetX = 58;
      state.offsetY = canvas.getBoundingClientRect().height / 2;
      draw();
    };
    root.querySelector('[data-rml-center]')?.addEventListener('click', centerArtwork);

    root.querySelectorAll('[data-surface]').forEach((button) => {
      button.addEventListener('click', () => {
        state.surface = button.dataset.surface;
        setPressed('[data-surface]', button);
        draw();
      });
    });

    root.querySelectorAll('[data-ink]').forEach((button) => {
      button.addEventListener('click', () => {
        state.ink = button.dataset.ink;
        setPressed('[data-ink]', button);
        draw();
      });
    });

    root.querySelectorAll('[data-roller]').forEach((button) => {
      button.addEventListener('click', () => {
        const diameter = Number(button.dataset.roller);
        if (![40, 50, 60].includes(diameter)) return;
        state.roller = diameter;
        setPressed('[data-roller]', button);
        if (rollerOutput) rollerOutput.textContent = `${(Math.PI * state.roller).toFixed(1)} mm / turn`;
        draw();
      });
    });

    const checkTextSupport = () => {
      state.textSupported = fonts[state.fontKey].cyrillic || !/[\u0400-\u052f]/u.test(state.text);
      if (state.fontReady && fontStatus) {
        fontStatus.textContent = state.textSupported ? '' : 'This font does not include Cyrillic. Choose Montserrat, Oswald or Rubik.';
        fontStatus.dataset.error = String(!state.textSupported);
      }
      syncSaveButton();
    };

    textInput?.addEventListener('input', () => {
      state.text = textInput.value.slice(0, 28);
      checkTextSupport();
      draw();
    });

    const loadFont = async () => {
      const key = fontInput?.value || 'montserrat';
      if (!Object.hasOwn(fonts, key)) return;
      const version = ++fontVersion;
      state.fontKey = key;
      state.fontReady = false;
      checkTextSupport();
      syncSaveButton();
      if (fontStatus) {
        fontStatus.textContent = 'Loading font...';
        fontStatus.dataset.error = 'false';
      }
      draw();
      try {
        if (document.fonts) {
          const loaded = await document.fonts.load(`${fonts[key].style || 'normal'} ${fonts[key].weight} 58px "RML ${fonts[key].family}"`, 'RollMyLogo');
          if (!loaded.length) throw new Error('Font unavailable');
        }
        if (version !== fontVersion) return;
        state.fontReady = true;
        if (textInput) {
          textInput.style.fontFamily = `"RML ${fonts[key].family}"`;
          textInput.style.fontWeight = String(fonts[key].weight);
          textInput.style.fontStyle = fonts[key].style || 'normal';
        }
        checkTextSupport();
      } catch (_error) {
        if (version !== fontVersion) return;
        if (fontStatus) {
          fontStatus.textContent = 'Font could not be loaded. Choose another font or reload the page.';
          fontStatus.dataset.error = 'true';
        }
      }
      syncSaveButton();
      draw();
    };
    fontInput?.addEventListener('change', loadFont);

    if (lineInput) lineInput.disabled = !state.lines;
    linesInput?.addEventListener('change', () => {
      state.lines = linesInput.checked;
      if (lineInput) lineInput.disabled = !state.lines;
      draw();
    });

    lineInput?.addEventListener('input', () => {
      state.lineWidth = Math.max(2, Math.min(10, Number(lineInput.value) || 4));
      if (lineOutput) lineOutput.textContent = `${state.lineWidth}px`;
      draw();
    });

    sizeInput?.addEventListener('input', () => {
      state.size = Number(sizeInput.value);
      if (sizeOutput) sizeOutput.textContent = `${state.size}px`;
      draw();
    });

    inverseInput?.addEventListener('change', () => {
      state.inverse = inverseInput.checked;
      draw();
    });

    const showUploadStatus = (message, error = false) => {
      if (!uploadStatus) return;
      uploadStatus.textContent = message;
      uploadStatus.dataset.error = String(error);
    };

    const clearLogo = () => {
      state.logo = null;
      state.source = null;
      state.filename = '';
      if (uploadFile) uploadFile.hidden = true;
      uploadThumb?.removeAttribute('src');
      if (uploadName) uploadName.textContent = '';
      setMode('text');
    };

    // Reduce large source images once, then keep only the printed area as an alpha mask.
    const prepareLogo = () => {
      const source = state.source;
      const mask = document.createElement('canvas');
      const scale = Math.min(1, 1024 / Math.max(source.naturalWidth, source.naturalHeight));
      mask.width = Math.max(1, Math.round(source.naturalWidth * scale));
      mask.height = Math.max(1, Math.round(source.naturalHeight * scale));
      const maskCtx = mask.getContext('2d', { willReadFrequently: true });
      maskCtx.drawImage(source, 0, 0, mask.width, mask.height);
      const pixels = maskCtx.getImageData(0, 0, mask.width, mask.height);
      let left = mask.width, top = mask.height, right = -1, bottom = -1;
      let hasTransparency = false;
      let hasVisibleAlpha = false;
      for (let i = 0; i < pixels.data.length; i += 4) {
        const p = pixels.data;
        if (p[i + 3] < 255) hasTransparency = true;
        if (p[i + 3] > 8) hasVisibleAlpha = true;
        if (state.removeWhite) p[i + 3] *= Math.min(1, (255 - Math.min(p[i], p[i + 1], p[i + 2])) / 35);
        p[i] = p[i + 1] = p[i + 2] = 0;
        if (p[i + 3] <= 8) continue;
        const x = (i / 4) % mask.width;
        const y = Math.floor(i / 4 / mask.width);
        left = Math.min(left, x); right = Math.max(right, x);
        top = Math.min(top, y); bottom = Math.max(bottom, y);
      }
      if (right < left) {
        // A white logo on transparency is valid artwork, not a white background.
        if (state.removeWhite && hasTransparency && hasVisibleAlpha) {
          state.removeWhite = false;
          if (whiteInput) whiteInput.checked = false;
          return prepareLogo();
        }
        throw new Error('No visible artwork found. Choose a logo with a visible shape.');
      }
      maskCtx.putImageData(pixels, 0, 0);
      const cropped = document.createElement('canvas');
      cropped.width = right - left + 1;
      cropped.height = bottom - top + 1;
      cropped.getContext('2d').drawImage(mask, left, top, cropped.width, cropped.height, 0, 0, cropped.width, cropped.height);
      state.logo = cropped;
    };

    whiteInput?.addEventListener('change', () => {
      state.removeWhite = whiteInput.checked;
      if (!state.source) return;
      try {
        prepareLogo();
        showUploadStatus('Logo ready.');
        draw();
      } catch (error) {
        state.removeWhite = whiteInput.checked = false;
        prepareLogo();
        showUploadStatus(error.message, true);
        draw();
      }
    });

    root.querySelector('[data-rml-remove]')?.addEventListener('click', () => {
      uploadVersion++;
      clearLogo();
      if (uploadInput) uploadInput.value = '';
      state.loading = false;
      syncSaveButton();
      showUploadStatus('Logo removed.');
    });

    uploadInput?.addEventListener('change', async () => {
      const file = uploadInput.files?.[0];
      if (!file) return;
      const version = ++uploadVersion;
      clearLogo();
      state.loading = true;
      if (addButton) addButton.disabled = true;
      showUploadStatus('Preparing logo...');
      try {
        const extension = file.name.split('.').pop().toLowerCase();
        const supported = ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'];
        if ((file.type && !supported.includes(file.type)) || !['png', 'jpg', 'jpeg', 'webp', 'svg'].includes(extension)) {
          throw new Error('Choose a PNG, JPG, WebP or SVG file.');
        }
        if (!file.size || file.size > 10 * 1024 * 1024) throw new Error('Choose a file smaller than 10 MB.');
        const dataUrl = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(new Error('The file could not be read. Please try again.'));
          reader.onabort = reader.onerror;
          reader.readAsDataURL(file);
        });
        if (version !== uploadVersion) return;
        const image = await new Promise((resolve, reject) => {
          const candidate = new Image();
          candidate.onload = () => resolve(candidate);
          candidate.onerror = () => reject(new Error('This image could not be opened. Try exporting it as PNG.'));
          // SVG is decoded only as an image, never inserted into the page as markup.
          candidate.src = dataUrl;
        });
        if (version !== uploadVersion) return;
        if (!image.naturalWidth || !image.naturalHeight || image.naturalWidth * image.naturalHeight > 40000000) {
          throw new Error('Image is too large. Export it below 40 megapixels.');
        }
        state.source = image;
        state.removeWhite = whiteInput ? whiteInput.checked : true;
        prepareLogo();
        state.filename = file.name;
        if (uploadName) uploadName.textContent = file.name;
        if (uploadThumb) uploadThumb.src = dataUrl;
        if (uploadFile) uploadFile.hidden = false;
        setMode('logo');
        centerArtwork();
        showUploadStatus('Logo ready.');
      } catch (error) {
        if (version !== uploadVersion) return;
        clearLogo();
        uploadInput.value = '';
        showUploadStatus(error.message || 'Unable to load this logo. Please try another file.', true);
      } finally {
        if (version === uploadVersion) {
          state.loading = false;
          syncSaveButton();
        }
      }
    });

    const positionFromEvent = (event) => {
      const rect = canvas.getBoundingClientRect();
      return { x: event.clientX - rect.left, y: event.clientY - rect.top };
    };

    canvas.addEventListener('pointerdown', (event) => {
      if (event.button !== 0) return;
      const point = positionFromEvent(event);
      state.dragging = true;
      state.lastX = point.x;
      state.lastY = point.y;
      canvas.setPointerCapture(event.pointerId);
    });

    canvas.addEventListener('pointermove', (event) => {
      if (!state.dragging) return;
      const point = positionFromEvent(event);
      state.offsetX += point.x - state.lastX;
      state.offsetY += point.y - state.lastY;
      state.lastX = point.x;
      state.lastY = point.y;
      draw();
    });

    const stopDrag = () => { state.dragging = false; };
    canvas.addEventListener('pointerup', stopDrag);
    canvas.addEventListener('pointercancel', stopDrag);

    productForm?.addEventListener('submit', (event) => {
      if (formReady) return;
      event.preventDefault();
      addButton?.click();
    });

    addButton?.addEventListener('click', () => {
      if (!state.fits || state.loading || (state.mode !== 'logo' && (!state.fontReady || !state.textSupported))) return;
      if (state.mode === 'text' && !state.text.trim()) {
        showUploadStatus('Add text or upload a logo before saving.', true);
        textInput?.focus();
        return;
      }
      const designData = {
        text: state.mode === 'logo' ? '' : state.text,
        size: state.size,
        fontSizeMm: layout.fontSizeMm,
        printWidthMm: 18.7,
        ink: state.ink,
        surface: state.surface,
        roller: state.roller,
        repeatLengthMm: Math.PI * state.roller,
        inverse: state.inverse,
        artwork: state.mode !== 'text' && Boolean(state.logo),
        mode: state.mode,
        removeWhite: state.removeWhite,
        fontKey: state.mode === 'logo' ? null : state.fontKey,
        fontFamily: state.mode === 'logo' ? null : fonts[state.fontKey].family,
        fontWeight: state.mode === 'logo' ? null : fonts[state.fontKey].weight,
        rails: { continuous: state.lines, top: state.lines, bottom: state.lines, thicknessPx: state.lines ? state.lineWidth : 0, thicknessMm: state.lines ? state.lineWidth / 6 : 0, gapMm: 4 / 6 },
        previewLayout: { ...layout },
        offsetX: Math.round(state.offsetX),
        offsetY: Math.round(state.offsetY),
      };
      if (designInput) designInput.value = JSON.stringify(designData);
      root.dispatchEvent(new CustomEvent('rollmylogo:design-ready', {
        detail: designData,
      }));
      if (isPreview) {
        const cart = readDemoCart();
        const thumbnail = document.createElement('canvas');
        thumbnail.width = Math.min(480, canvas.width);
        thumbnail.height = Math.max(1, Math.round(canvas.height * thumbnail.width / canvas.width));
        thumbnail.getContext('2d').drawImage(canvas, 0, 0, thumbnail.width, thumbnail.height);
        cart.push({
          id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
          title: 'Custom RollMyLogo Roller',
          quantity: 1,
          text: designData.text || state.filename,
          size: designData.size,
          fontSizeMm: designData.fontSizeMm,
          printWidthMm: designData.printWidthMm,
          ink: designData.ink,
          surface: designData.surface,
          roller: designData.roller,
          repeatLengthMm: designData.repeatLengthMm,
          inverse: designData.inverse,
          artwork: designData.artwork ? state.filename : '',
          mode: designData.mode,
          removeWhite: designData.removeWhite,
          fontKey: designData.fontKey,
          fontFamily: designData.fontFamily,
          fontWeight: designData.fontWeight,
          rails: designData.rails,
          previewLayout: designData.previewLayout,
          previewImage: thumbnail.toDataURL('image/png'),
        });
        try {
          window.localStorage.setItem(demoCartKey, JSON.stringify(cart));
        } catch (_error) {
          showUploadStatus('The design could not be saved in this browser. Please free some storage and try again.', true);
          return;
        }
        updateDemoCartCount();
        if (toast) {
          toast.textContent = 'Design added to cart. Open Cart to review it.';
          toast.classList.add('is-visible');
          window.setTimeout(() => toast.classList.remove('is-visible'), 2800);
        }
        return;
      }
      if (productForm) {
        productForm.enctype = 'multipart/form-data';
        if (uploadInput) uploadInput.disabled = !designData.artwork;
        formReady = true;
        try {
          productForm.requestSubmit();
        } finally {
          formReady = false;
          if (uploadInput) uploadInput.disabled = false;
        }
        return;
      }
      if (toast) {
        toast.classList.add('is-visible');
        window.setTimeout(() => toast.classList.remove('is-visible'), 2800);
      }
    });

    new ResizeObserver(resize).observe(canvas);
    resize();
    loadFont();
  });
})();
